import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { IntroContent } from './IntroContent';
import { InformationCollection } from './InformationCollection';
import { YourAccess } from './YourAccess';
import { SecuritySection } from './SecuritySection';
import { ContactConcerns } from './ContactConcerns';
import { QuickLinks } from './QuickLinks';
export function PrivacyPolicyPage() {
  return <PageLayout data-id="element-2767">
      <HeaderBanner data-id="element-2768" />
      <IntroContent data-id="element-2769" />
      <InformationCollection data-id="element-2770" />
      <YourAccess data-id="element-2771" />
      <SecuritySection data-id="element-2772" />
      <ContactConcerns data-id="element-2773" />
      <QuickLinks data-id="element-2774" />
    </PageLayout>;
}